/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Dashboard patient card
 */

// Dependencies
import { Col } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './styles.module.css';

const DashboardPatientCard = ({ data }) => {
  // if (!data) return <span style={{ display: '' }}></span>;
  return (
    <Col
      style={{ display: !data && 'none' }}
      xs={12}
      sm={12}
      md={6}
      lg={6}
      xl={4}>
      <Link to={data?.link || ''}>
        <div
          className={[styles.dashboardCard, data?.background || ''].join(' ')}>
          <h1
            className={`font-bold mb-0 text-base md:text-lg1 text-center
            ${data?.titleStyles ?? 'text-white'}`}>
            {data?.title || ''}
          </h1>
          {data?.mainIcon || ''}
          <div className="flex flex-row justify-center items-center datas-center text-center">
            <h1
              className={`font-bold mb-0 text-base md:text-lg1 
              ${data?.textStyles ?? 'text-white'}`}>
              {data?.footer?.text || ''}
            </h1>
            {data?.footer?.icon && (
              <div className="ml-2">{data?.footer?.icon || ''}</div>
            )}
          </div>
        </div>
      </Link>
    </Col>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardPatientCard.propTypes = {
  data: PropTypes.shape({
    link: PropTypes.string,
    background: PropTypes.string,
    title: PropTypes.string,
    mainIcon: PropTypes.element,
    footer: PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.element
    }),
    textStyles: PropTypes.string,
    titleStyles: PropTypes.string
  })
};

export default DashboardPatientCard;
